// extracted by mini-css-extract-plugin
export var container = "plan-module--container--iBav3";
export var flex_container = "plan-module--flex_container--Ya2U0";
export var table = "plan-module--table--Sg7Vc";
export var wrapper = "plan-module--wrapper--DLlPD";